module.exports = __webpack_public_path__ + "static/media/google-button.3831b377.png";